export const OC_RESULT_DESCRIPTION = {
    INSTANCE_FAILURE: [
        [
            "You tried to raid a run-down hotel suspected of storing stolen loot.",
            "Instead, a dozen squatters fought back with bats and bricks. Your car was stripped while you bled in the alley. No bullets. No booze. No cash.",
            "Just bruises and humiliation. The cops never came—no one called them.",
            "Too dirty for even them.",
        ],
        [
            "You were tipped off about a moonshine stash hidden in old car chassis.",
            "Instead, a rival crew ambushed you.",
            "You took cover behind a ‘31 Dodge, but bullets flew like rain.",
            "Your partner took one in the leg.",
            "You dragged them out and lost your own ride in the shootout.",
            "No cash. No moonshine.",
            "It was a setup from the start.",
        ],
        [
            "You tried robbing a textile mill run by opium dealers.",
            "Mid-job, someone sparked a fire.",
            "Flames swallowed the upper floor, your escape path.",
            "Nothing left but ash and coughing lungs.",
            "No cash. No drugs.",
            "Just a lesson scorched into memory.",
            "You walked home holding each other up.",
        ],
        [
            "Word was there were crates of contraband down at Pier 6.",
            "Instead: an ambush. Three goons with knives and clubs.",
            "You limped out through the dock maze, bleeding and cursing.",
            "No loot. No bullets. Just pain and humiliation.",
            "You never speak of that night.",
        ],
        [
            "A whisper told you about loot hidden in an old vaudeville theater.",
            "Turned out to be a trap set by rivals.",
            "They jumped you backstage and beat you down. Your car was set ablaze.",
            "No cash. No credits. Just blood on the curtains and rage in your throat.",
            "You’ll return one day—armed.",
        ],
        [
            "The tip said there were unguarded crates of cocaine in a shipping hub near the docks. But it was bait. You and your partner bust open a few crates—just flour. Then the alarm howls, and floodlights hit you. You try to run, but bullets rain down from above. You dive for cover behind a forklift, taking a shot to the ribs.",
            "You barely make it out. No loot. No car. Just pain.",
        ],
        [
            "You and your partner attempted to rob a rival's basement brewery.",
            "Turns out the guy had tripwire triggers on the mash tanks.",
            "Boom. You both flew through the air and into the alley",
            "No loot. No car — yours was crushed by a falling wall.",
            "The street smelled of burned yeast and blood.",
            "A single unbroken beer bottle rolled into your hand.",
            "You drank it in silence.",
        ],
        [
            "You hit a traveling vaudeville show’s safe room backstage.",
            "Expected show money, but found a setup.",
            "Two goons, one tommy gun, and no exit.",
            "You jumped off the roof and your car was impounded during the act.",
            "You limped home with nothing but bruises and rage.",
            "No drugs, no drinks, no loot.",
            "The theatre still plays twice a week—you still avoid it.",
        ],
        [
            "The Grand Hotel held a political bribe exchange in Room 807.",
            "You barged in—too early. Two men with tommy guns opened fire.",
            "You dove out a window and landed hard in the alley.",
            "The money never left its briefcase. Your ride was blocked in by cops.",
            "You walked home bleeding, bitter, and broke.",
        ],
        [
            "You hit a farmhouse where a crooked sheriff stored seized liquor.",
            "The family returned early and lit the barn to trap you.",
            "Flames cut off your exit—you dove through a window.",
            "The car was torched: gone in smoke. You crawled out with one beer bottle intact. No cash, no credits. Just fire scars and shame.",
        ],
        [
            "Last job of the month. You tried hitting a freight train at night.",
            "Jumped the wrong car—nothing but rocks and rats. Then a rival crew spotted you and gave chase. Your car was gone—hotwired by someone else. No bullets, no credits, no nothing.",
            "You limped home in the rain, bleeding and empty.",
            "Crime doesn’t always pay. But you’ll try again.",
        ],
        [
            "The cabin was supposed to house moonshine—turns out it housed killers.",
            "They were waiting, silent in the trees. They knifed your tires, broke your nose, and took your bullets. No car, no loot, and a long walk back to town.",
            "Your shoes filled with blood and lake water.",
            "You vowed never to trust mountain tips again.",
            "Sometimes the job costs everything.",
        ],
        [
            "You raided a tenement flat full of fiends.",
            "Found 3 morphine doses, 2 opium packets, and 5 bottles of glue.",
            "Then someone dropped a lantern.",
            "The place went up fast.",
            "You escaped through the back, but took damage.",
            "Partner came out coughing blood.",
            "You lost your car in the flames. You swore never to hit a junkie den again.",
        ]
    ],
    SUCCESS: [
        [
            "A midnight smash-and-grab on an uptown grocer’s back office.",
            "You were told it was a numbers racket—turns out, they dealt in dope.",
            "Stacks of small bills, plus a bag of loose powders and sealed jars.",
            "You take the safe and run, alarms screaming behind you.",
            "Cops show up late, you’re long gone.",
            "The Buick backfires like a cannon on the way out.",
        ],

        [
            "The target is a crooked pharmacy front near the wharf.",
            "The clerk panics when you flash your badge—he thinks you're real G-men. You take the locked drawers and a hidden case from the back.",
            "Outside, your partner hotwires a delivery van, and you're off.",
            "The loot’s nothing to sneeze at.",
        ],

        [
            "The gig was supposed to be low-level—a speakeasy raid, in and out.",
            "But the place doubled as a stash house for imported meds.",
            "You find a false wall behind the bar, stocked with jars and cases.",
            "While your partner distracts the bartender, you empty the shelves.",
            "A quick dash out the back into the snow seals the job.",
            "Silent and smooth.",
        ],

        [
            "You knock over a backroom poker game in Chinatown.",
            "The players don't resist—too high to fight, too rich to run.",
            "The real prize sits behind a hidden door: narcotics stacked like books.",
            "You grab what you can before your partners triggers an alarm.",
            "Out the window, down the fire escape, through the alley.",
            "The job ends with bruises, not blood.",
        ],

        [
            "You hit a small-town bank under cover of a Fourth of July parade.",
            "Fireworks mask the safe’s charge, and everyone thinks it’s part of the show. Your partners loads the bills while you snatch a crate labeled 'Pharmacy.'",
            "One bullet grazes your shoulder on the way out—a sheriff on lunch break.",
            "You make it out in a stolen fire truck, oddly fitting.",
            "You’ll laugh about it—later.",
        ],

        [
            "You break into a rival gang's stash house through a basement coal chute.",
            "Inside, crates are stamped with fake church logos—classic cover.",
            "Your partner finds a safe in the wall; you find a trapdoor full of liquor.",
            "The safe pops after three tries, and you load what you can carry.",
            "You vanish before the crew returns from their poker game upstairs.",
            "Clean exit, no gunfire.",
        ],

        [
            "The hotel heist goes too smooth—it worries you.",
            "Turns out the place was under surveillance, not just guarded.",
            "You clean the room out regardless: cases of heroin hidden in a piano, cash in the walls.",
            "But you barely escape through the laundry chute as feds rush the lobby.",
            "The car takes two bullets, your partner one.",
            "You drive into the night, swearing never to trust 'easy' again.",
        ],

        [
            "An elite auction house holds more than art.",
            "You and your partner sneak in as janitors, then cut the power mid-bid.",
            "In the dark, you loot a hidden vault below the bidding floor.",
            "The score includes both narcotics and cash from the night’s high-stakes buyers.",
            "One crate of vodka is labeled “Polish Soap.”",
            "You don’t care—it's good drinking.",
        ],

        [
            "The armored car is old and slow—just like its driver.",
            "You block it with a fake construction crew and yank the guards out at gunpoint. Your partner blows the rear hatch while you keep watch.",
            "Inside are stacks of sealed envelopes and bundles of bills.",
            "You leave the guards alive—just barely.",
            "A clean getaway over a river bridge seals it.",
        ],

        [
            "Your partners dresses as guests, you pose as an undertaker.",
            "It’s a funeral for a mob boss—so naturally, the safe’s under the coffin.",
            "You wait until the eulogy hits its peak, then make your move.",
            "Five minutes later you’re in the basement, cracking the lock.",
            "A thunderstorm covers your escape into the cemetery.",
            "Dead quiet, filthy rich.",
        ],

        [
            "The chop shop job is chaos from the start.",
            "You thought they’d be unarmed—wrong.",
            "You get the drop on two guards but the third fires wild.",
            "A round grazes your arm as your partner plows through the office wall.",
            "The back room’s got crates of dope, liquor, and more green than expected. You limp away, clutching your haul.",
        ],

        [
            "The high-rise vault in Midtown is an old-timer’s tale—until you find it.",
            "It takes all night, a blowtorch, and three bribes to reach it.",
            "What’s inside looks like a king’s ransom: stacks of green, and shelves of locked crates.",
            "You grab what you can carry before the floorboards start groaning.",
            "The cops don’t catch up until you’re already in Jersey.",
            "Your Partners’s faces is smeared with soot, but he’s laughing anyway",
        ],

        [
            "A tip leads you to a luxury freight train loaded with contraband.",
            "You hop aboard mid-route and cut through the floor into the liquor car.",
            "Guards show up halfway through, but your partners handles them with precision. You toss barrels and bundles out the window to your crew below.",
            "By the time the train hits the next stop, it’s light as a feather.",
            "And you’re long gone in your car.",
        ],

        [
            "The pharmaceutical shipment ambush is risky, but you need a score.",
            "You pose as customs agents, stopping the truck at the bridge checkpoint.",
            "The driver panics, but a slap from your partners settles him.",
            "Inside: white powder, black vials, and two cases of crisp bills.",
            "You torch the plates and vanish into the fog.",
            "You all get high off success (and maybe something else).",
        ],
        [
            "You and your partner crack the vault under Lombardi’s Casino at 3 a.m.",
            "The guards are drugged, the alarm is looped, and the timing’s perfect.",
            "The vault opens like a can of beans, revealing bricks of cash and crates marked “med supplies.”",
            "You don’t ask questions—you just load up the trunk.",
            "As you speed away into the night, Benny lights a cigar and grins.",
            "“We just hit the jackpot, pal.”",
        ],

        [
            "A corrupt politician throws lavish parties with secret stashes of imported liquor in the cellar. You charm your way past the help, posing as musicians. Once inside, you sneak to the wine vault, bypass the lock, and find crates of cognac stamped with foreign seals. But a nosy servant catches you and raises the alarm. You fight your way out through a kitchen of cleaver-wielding cooks.",
            "You’re drunk, cut, and successful.",
        ],

        [
            "Your partners disguises themselves as patients to distract the doctor while you break into his backroom dispensary. Hidden inside a hollow wall are bundles of amphetamines, stashed for underground runners. The doc catches on and pulls a revolver, but your partner clocks him with a bedpan. You drive off with a bag of goods and bruised knuckles.",
            "You feel like heroes… dirty heroes.",
        ],

        [
            "You hit a rival crew’s backroom operation where they store favor notes and IOUs in a filing cabinet disguised as furniture. You crack the office at 3AM, and your partner holds lookout. You leave with stacks of coded notes, plus a briefcase full of emergency bullets. But as you exit, a junkie guard lunges at you with a broken bottle. You wrestle free, but his slash leaves a deep gash",
        ],

        [
            "You and your partners hit a speakeasy in St. Louis during a police raid. Everyone's running, screaming, ducking. You slip past the chaos, straight into the backroom where the safe sits behind a painting of Calvin Coolidge. While your partners cracks the safe, you fill your satchel with whatever liquor and money you can find. On your way out, a bullet tears through your side—but you're alive.",
            "The city’s drunk, and you’re a little richer.",
        ],

        [
            "You robbed a riverboat poker game hosted by a mayor's cousin.",
            "Players panicked—no one fired a shot. You dove off the boat into your car.",
            "Your partners laughed the whole ride back. You celebrated with wine and jazz. Some nights feel like a movie.",
            "That one was a masterpiece.",
        ],

        [
            "You broke into a cold storage linked to a whiskey smuggling ring.",
            "Your fingers went numb hauling crates into your car.",
            "The engine froze but still roared to life. You drove fast to warm up.",
            "Your partner popped a whiskey open to thaw out. You drank straight from the bottle—earned it.",
        ],

        [
            "You hit a mahjong den hiding more than gambling.",
            "You ducked under red lanterns and slipped out just as police raided the front. Your partner hotwired a Bentley Speed Six Saloon for the escape.",
            "You drove through fish markets and alleys like ghosts.",
            "Somewhere along the way, you lost your hat.",
            "You didn’t care.",
        ],

        [
            "Back on the rails, you stopped a coal train with a dynamite charge.",
            "The smell of coal mixed with sweet liquor and black powder.",
            "You loaded the loot fast, boarded a parked car nearby.",
            "As you drove, the train exploded behind you—timing was close.",
            "Your partners screamed in joy.",
            "The whiskey spilled over the cash. You drank from it anyway.",
        ],

        [
            "You hit the mayor’s country estate while he vacationed in Havana.",
            "You drove off smooth, windows down, hearts racing.",
            "No alarms, no witnesses. Just birdsong and soft tires on gravel.",
            "Your partner sang old war songs.",
            "You both laughed the whole way to the warehouse.",
        ],

        [
            "You dropped in from a fire escape to the penthouse of a gangster’s mistress.She wasn’t there, but her jewels were",
            "You made it down five floors before the cops showed.",
            "One saw you, but your partners shot out a light—clean escape.",
            "The car? Still running at the curb. The port made the ride feel royal.",
            "You’ll remember that rooftop forever.",
        ],

        [
            "You broke into the old icehouse on Dock Street.",
            "Found a hidden crate labeled “Fish” It was guarded only by a sleeping dog and a padlock. Easy take.",
            "You wheeled it out on a dolly, stuffed it into your car.",
            "The tires were bald, but held long enough.",
            "You celebrated with a warm beer and cold cash.",
            "Best fish you never ate.",
        ],

        [
            "You rappelled into a boarded textile factory hiding crates.",
            "One guard was asleep—thankfully.",
            "You dragged crates out through a sewer grate.",
            "It took hours and cost you your car, lost in the factory collapse.",
            "But you got out, reeking of rot but rich.",
        ],

        [
            "This “butcher” sold nothing but blood and contraband.",
            "You broke in through the back and found some loot.",
            "The floor was slick with lard and made for a hellish exit.",
            "Your partner slipped, spraining a wrist",
            "You hauled them into a battered but fast car.",
            "That car roared all the way to your drop point.",
            "The meat was fake, but the money wasn’t.",
            "You left red footprints behind.",
        ],

        [
            "The lawyer had ties to every racket in the city — and a wall safe.",
            "The legal files inside made you shiver.",
            "You torched the desk before leaving — insurance and erasure.",
            "Drove off calm, almost bored.",
            "Your partner hummed a church tune.",
            "Some nights, it's just too easy.",
            "And too profitable to question.",
        ],

        [
            "You slipped into the second floor of a brothel rumored to run blackmail and booze.",
            "Under the madam’s bed was a safe.",
            "One drunk tried to stop you—he lost a tooth.",
            "You left him tied up in fishnet stockings.",
            "You cracked open the wine on a rooftop to celebrate.",
            "The city lights blurred with laughter. Your pockets heavy, your conscience light.",
        ],

        [
            "You hit a meatpacking plant fronting for a gang moving morphine in pig carcasses.",
            "Hidden in a gutted boar you found some loot.",
            "You gagged from the stench but stuffed the loot into your coat anyway.",
            "Your partner drove the stolen car like a bat out of hell.",
            "A guard got one shot off, grazing your shoulder",
            "Still, you made it to the city border before the sirens grew faint.",
            "You tossed the boar back onto the loading dock for luck.",
            "Crime is messy—but profitable.",
        ],

        [
            "A blizzard helped cover your tracks to a mountain cabin used for exchanges.",
            "You slid your car into a drift on the escape but walked away.",
            "The partner grabbed the cash and didn’t even notice the drugs.",
            "The amphetamines helped keep you awake for the cold hike home.",
            "You abandoned the car under a pine tree.",
            "Better it freeze than be found.",
            "Money warms faster than whiskey ever could.",
        ],

        [
            "You broke into the dentist's office at midnight, suspecting hidden revenue.",
            "In the X-ray room, you found his stash.",
            "As alarms rang, you slipped down the fire escape and into your car.",
            "The tires screeched and you disappeared into the fog.",
            "No bullets, no injuries—just clean loot and shaky nerves.",
            "You don’t trust dentists anymore.",
            "Too many secrets under the floorboards.",
        ],

        [
            "You intercepted a coal train rumored to be hiding cartel shipments.",
            "Under a false floor, you uncovered a gold mine.",
            "Two bottles cracked during the escape, soaking the cash in firewater.",
            "You dried the bills in the heat of your cars engine.",
            "Your partner toasted the night with the rest.",
            "The whiskey was smoky and bitter, just like your escape.",
            "You burned the coal car for cover.",
            "The Feds never traced it.",
        ],

        [
            "A Prohibition gang was hiding their stash in an abandoned silver mine.",
            "You tunneled down, torch in hand, and cracked their steel case.",
            "A cave-in forced you to leave your ride up top.",
            "You drove away in an old getaway car that still started.",
            "The paint peeled, but the engine roared.",
            "You left your old wheels buried in the mountain.",
            "Felt like a trade with the devil.",
        ],

        [
            "The town barber had no customers but owned five buildings.",
            "You followed him one night to a hidden vault beneath the floorboards.",
            "You drove off with both and never looked back.",
            "He reported it as “vandalism,” too scared to admit what was really stolen.",
            "The coupe still had scissors in the glove box.",
            "You laughed about that for weeks.",
            "Crime really does pay—sometimes.",
        ],

        [
            "A rich tycoon was hosting a high-stakes game in his mansion.",
            "You posed as waiters and found the locked case under the table.",
            "Your exit was through the servant’s path, quiet and clean.",
            "You laughed all the way to the hills.",
            "The mansion sat in your rearview like a ghost.",
            "A rich man’s pride is easy to break.",
        ],

        [
            "Word on the street said a priest was laundering money through the Sunday tithe.",
            "You broke in through the bell tower after hours.",
            "Found the stash and a note that read: “God forgives, the Feds don’t.”",
            "You split the loot and stole the priest’s pride.",
            "The getaway was quiet, almost reverent.",
            "Amen.",
        ],

        [
            "You hit a hidden room behind a jazz club rumored to house mob funds.",
            "Turned out it held more than you expected.",
            "The barkeep saw you, but a slip of cash bought silence.",
            "Your partners tripped down the cellar stairs but kept hold of the bag.",
            "You loaded the loot into your car and drove off humming.",
            "No heat on your tail.",
            "Just jazz on the radio and powder on your lap.",
        ]
    ],
    FAIL_AWAY: [
        [
            "Word was a rogue doctor was trading health credits for dope and favors.",
            "You found the basement clinic and the stash.",
            "Just as you stuffed them into a satchel, the doc pulled a pistol.",
            "He shot your partner in the leg.",
            "You ditched the job and the car after crashing into a lamp post.",
            "No cash, no bullets",
            "The doc never reported it.",
            "Bad for business, after all.",
        ],
        [
            "You snatched the wrong case off the platform at Union Station.",
            "Inside: zero cash—but 300 wine bottles and 500 port, clearly smuggled imports.",
            "The conductor chased you with a wrench.",
            "You jumped the turnstile, lost 18 health, and tore your coat.",
            "No bullets. No credits.",
            "You drank one for the road.",
            "Felt like the end of prohibition all over again.",
        ],

        [
            "You stormed a bootleggers’ hideout in a riverside warehouse.",
            "   They were better armed than expected—one tossed a crate your way.",
            "It cracked open, revealing 70 bottles of tequila and 35 of vodka.",
            "No money. No bullets.",
            "Just bruises, broken glass, and hangovers in your stolen car.",
            "You tossed the liquor, if only to dull the pain.",
            "A sour night all around.",
        ],

        [
            "You snuck into the nightshift payroll office at the steel mill.",
            "A guard heard the creak of the door and came swinging with a crowbar.",
            "You blocked it, but your partner caught a blow to the ribs",
            "The car barely started—a beat-up car—but you got away.",
            "Metal clanged behind you as sirens howled into the smoke.",
            "You never looked back.",
        ],

        [
            "The parlor was a cover for drug shipments in frozen bricks.",
            "You cracked the freezer and found nothing of value.",
            "You left your jalopy behind and slid the car through backstreets.",
            "Your partner couldn’t stop laughing..",
            "The irony was delicious.",
        ],

        [
            "Behind the altar, hidden stairs led to a vault.",
            "You cracked it open but nothing was there.",
            "The priest walked in on you—froze, then fainted.",
            "You left a $20 in the donation plate out of guilt.",
            "Your car sped out of the district like a whisper.",
            "You shared one port bottle with your partners",
            "Redemption comes later.",
        ],

        [
            "Masked and fast, you hit a jazz club doubling as a stash house.",
            "A trumpet player tried to tackle you—mistake.",
            "He woke up with a fat lip and no cash.",
            "You escaped in a stolen Chrysler Imperial Model 80 Roadster.",
            "Your partner played the trumpet all the way home.",
            "Badly. You didn’t mind. A wasted night out.",
        ],

        [
            "You and your partner bribe a railway switchman to delay a cargo train rumored to carry contraband from the docks. After hopping aboard just past midnight, you locate a locked crate marked \"Medical Supplies.\" With bolt cutters in hand, you pry it open and uncover vials of morphine nestled between packing straw. As you're making your escape, a railroad guard spots you—gunfire erupts. You both dive into a ditch, hearts pounding. Close call.",
        ],

        [
            "Just outside of the city, you and your partner break into an old distillery recently taken over by a rival crew. The place is crawling with lazy sentries nursing drinks. You cut the power and slip through the shadows, loading crates of aged whiskey and a few barrels of unmarked goods. But while backing the truck out, a Molotov cocktail hits your getaway car. You escape in a hail of fire, coughing and bleeding. You are lucky to be alive"
        ],

        [
            "Inside a nondescript warehouse, you find more than you bargained for—wooden crates filled with adhesive drums and crates labeled “Munitions.” You slip past a pair of card-playing guards and load what you can. One crate bursts open during transport, coating your clothes in thick glue. When a guard hears the noise and fires a shot, you both bolt—your partner gets clipped in the leg.",

            "Sticky, hurt, but lucky to be alive.",
        ],

        [
            "A crooked importer in El Paso hides smuggled spirits in an abandoned mission. You and your partners arrive before dawn, disable the only guard with a sap to the neck, and start hauling cases of tequila into your truck. Just before you leave, a rattlesnake slithers from a crate and bites your leg. Your partner drives like hell to get you to Doc Walters.",
            "It costs you some blood and embarrasment"
        ],

        [
            "You impersonate hospital staff to gain access to the locked dispensary infirmary. The night nurse buys your story, and your partner creates a distraction down the hall. You sneak into the back, load morphine ampoules into a doctor’s bag, and slip out just before the real doctor arrives. You're almost clear when the nurse spots your partner bleeding. She calls the cops.",
            "You barely make it to the car under sirens. Its game over"
        ]
    ]
}